module.exports = __webpack_public_path__ + "static/media/10.3bd60317.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/moan/10.mp3
// module id = 486
// module chunks = 0